import React from 'react'
import { useTranslation } from 'react-i18next'

import { useToastContext } from '../../../../../../contexts'
import { getHandleableError } from '../../../../../../utils/errors/isXiaError'
import { useRoleAssignmentById } from '../../../data'
import { requestDeleteRoleAssignmentById } from '../../../data/api'
import { DeleteAssignee } from './DeleteAssignee'

type Props = {
  setIsRequestRunning: (params: boolean) => void
  id: string
  visible: boolean
  onHide: () => void
  mutate: () => void
}

export const DeleteAssigneeContainer: React.FC<Props> = ({
  setIsRequestRunning,
  id,
  visible,
  mutate,
  onHide,
}) => {
  const { t } = useTranslation()
  const { data: roleAssignment } = useRoleAssignmentById(id)
  const { showToast } = useToastContext()

  const deleteRoleAssignment = async (id: string) => {
    try {
      onHide()
      setIsRequestRunning(true)

      await requestDeleteRoleAssignmentById(id)

      // show success toast
      showToast({
        style: {},
        closable: true,
        severity: 'success',
        summary: t(
          'roleAssignments.table.delete.dialog.delete.messages.success.summary',
        ),
        detail: t(
          'roleAssignments.table.delete.dialog.delete.messages.success.detail',
          {
            email: roleAssignment?.assignee,
          },
        ),
      })
    } catch (error) {
      let handleableError = getHandleableError(error)
      let errorMessage = handleableError.message

      // show error toast
      showToast({
        style: {},
        closable: true,
        severity: 'error',
        sticky: true,
        summary: t(
          'roleAssignments.table.delete.dialog.delete.messages.failure.summary',
        ),
        detail: errorMessage,
      })
    } finally {
      setIsRequestRunning(false)
      mutate()
    }
  }

  return (
    <DeleteAssignee
      onClickHandler={() => deleteRoleAssignment(id)}
      isVisible={visible}
      role={roleAssignment?.role}
      assignee={roleAssignment?.assignee}
      project={roleAssignment?.project}
      onHide={onHide}
    />
  )
}
